export const SystemFieldCodeMap = [
  { label: '姓名', value: 'name' },
  { label: '性别', value: 'gender' },
  { label: '手机', value: 'mobile' },
  { label: '邮箱', value: 'email' },
  { label: '公司', value: 'company' },
  { label: '部门', value: 'department' },
  { label: '职务', value: 'position' },
  { label: '证件', value: 'certificate' },
  { label: '头像', value: 'avatar' },
  { label: '地址', value: 'address' },
  { label: '邮编', value: 'zipcode' },
  { label: '国籍', value: 'nationality' },
  { label: '车辆编号', value: 'vehicleNumber' },
  { label: '展位号', value: 'boothNo' },
  { label: '分类', value: 'category' },
  { label: '摘要题目', value: 'abstractTitle' },
  { label: '拟投稿议题', value: 'proposedSubmissionTopics' },
  { label: '投稿类别', value: 'submissionCategories' },
  { label: '关键字', value: 'keywords' },
  { label: '摘要内容', value: 'abstractContent' },
  { label: '摘要附件', value: 'abstractAttachment' },
  { label: '拟交流类型', value: 'proposedCommunicationType' },
  { label: '英文题目', value: 'titleEn' },
  { label: '方法', value: 'methods' },
  { label: '结果', value: 'results' },
  { label: '结论', value: 'conclusion' },
  { label: '参考文献', value: 'references' },
  { label: '中文壁报', value: 'poster' },
  { label: '英文壁报', value: 'posterEn' },
  { label: '中文全文附件', value: 'fullTextAttachment' },
  { label: '英文全文附件', value: 'fullTextAttachmentEn' },
  { label: '视频附件', value: 'videoAttachment' },
  { label: 'PPT中文', value: 'PptCn' },
  { label: 'PPT英文', value: 'PptEn' },
  { label: '姓', value: 'lastName' },
  { label: '名', value: 'firstName' },
  { label: '工作单位', value: 'institution' },
  { label: '工作单位（英文）', value: 'institutionEn' },
  { label: '出生日期', value: 'birthday' },
  { label: '护照', value: 'passport' },
  { label: '护照签发日期', value: 'passportIssueDate' },
  { label: '护照到期日期', value: 'passportExpireDate' }
]

// 绑定参会人不需要登录的associatedType key 集合
export const noTokenAssociatedTypeKeys = ['ExhibitorMember']
